import WebProductTypeEdit from './WebProductTypeEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../../utilsTsx/components/system/columnshead';
import { useEffect, useRef, useState } from 'react';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import { Space } from 'antd';
import CustomSelect from '../../../utilsTsx/components/hooks/CustomSelect';

const WebProductType = (props: any) => {

    const apiId = 'webProductType';
    const ref = useRef<any>(undefined);
    const [fetchData, setFetchData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>();
    const [productCategoryData, setProductCategoryData] = useState<any>();

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setFetchData(() => ref.current.fetchData);
            setSendPageData(ref.current.sendPageData);
        }
        fetchApi.GET(urlService,
            {
                query: {
                    apiId: 'webProductCategory',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setProductCategoryData([{ id: 'ALLITEM', categoryName: '所有大类' }, ...res.data]);
                }
            })
    }, []);

    const columnsHead = [
        {
            title: '大类',
            dataIndex: 'productCategory',
            render: (val: any) => val?.categoryName
        },
        {
            title: '分类',
            dataIndex: 'typeName',
            sorter: true,
        },
        {
            title: '排序',
            dataIndex: 'sortBy',
            sorter: true,
        },
    ];
    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '产品分类',
        apiId,
        columns,
        editOptions: {
            Editor: WebProductTypeEdit
        }
    };

    return (
        <> <Space>
            <CustomSelect
                apiId={apiId}
                sendKeyId='productCategoryId'
                getListData={productCategoryData}
                sendPageData={sendPageData}
                setSendPageData={setSendPageData}
                fetchData={fetchData}
                itemName="categoryName"
            />
        </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
        </>)
}

export default WebProductType;
